import React from 'react'

export const DemoApp = () => {
    return (
        <div>
            <div className={'text-lg font-medium'}>DemoApp</div>
        </div>
    )
}
